import React, { useState } from 'react'
import * as Location from 'expo-location'
import {
    CountryGetLocalization,
    FieldGetLocalization,
    Organization,
    SingleGetLocalization,
} from '../../../services/interfaces/schedule.interface/schedule.getlocalizationdata.interface'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_create_pos, request_get_localization_data } from '../../../services/schedule.services'
import { generateUniqueId, schedulesServices } from '../../../../database/schedules.database'
import { COUNTRY_ID_ARG } from './useCreateStore'
import { ORGANIZATION_STATUS, STATUS_SEND, STORE_STATUS } from '../constants/constants.stores'
import { textTransformUpperCase } from '../../../utils/functions.utils'
import { PostsServices } from '../../../../database/posts.database'
import { SCHEDULES_STORE_NAMES } from '../../../db/posSchedules'
import { DataSendRequestCreatePos, dataCreatedDbLocalI, OrganizationCreateStore, SchedulePosCreateStore, StoreCreateStore, org } from '../interfaces/useCreatePose.interface'

const DATE_15m = 1000 * 60 * 15
const DATE_DIF = DATE_15m

export const useCreatePos = () => {
    const [fields, setFields] = useState([])
    const [fieldsOrganization, setFieldsOrganization] = useState([])
    const [options, setOptions] = useState([])
    const [isVisibleFormOrganization, setIsVisibleFormOrganization] = useState(false)
    const [loading, setIsLoading] = useState(true)
    const [provinces, setProvinces] = useState([])
    const [selectedProvince, setSelectedProvince] = useState({ _id: '', cities: [] })
    const [cities, setCities] = useState([])
    const [optionsOrganizations, setOptionsOrganizations] = useState<Organization[]>([])

    const citys = cities.filter((city) => city.province_id === selectedProvince._id)

    const handleSaveStore = async (form, isVisibleFormOrganization = false) => {
        try {
            // console.log('form results => ', JSON.stringify(form, null, 2))

            // const isValidForm = isValidFieldsForms(form)
            // console.log('isValidForm => ', isValidForm)

            // if (!isValidForm) {
            //     console.log('formulario invalido...')
            //     // return //! DESCOMENTAR EL RETURN PARA EVITAR ENVIAR FORMULARIOS INVALIDOS
            // }

            const dataSend = await transformDataKeys(form, isVisibleFormOrganization)

            if (dataSend == null) {
                console.log('formulario invalido... dataSend')
                return null
            }

            let { status, pos, schedule_pos, organization } = await sendStore(dataSend)

            const dataCreated: dataCreatedDbLocalI = {
                organizationCreate: organization,
                posCreate: pos,
                schedulePosCreate: schedule_pos,
            }

            const responseCreateSqlite = await createStoreInDBLocal(status, dataCreated, dataSend) // !comento por ahora

            if (responseCreateSqlite != null && responseCreateSqlite !== -1) {
                await saveDataPendingSend(status, dataSend, responseCreateSqlite)
            }

            let statusReturn = validateStatusReturnSaveStore(responseCreateSqlite, status)
            console.log('59 =====> statusReturn =====> ', JSON.stringify(statusReturn))

            return statusReturn
        } catch (error) {
            console.error('handleSaveStore => ', handleSaveStore)
            return null
        }
    }
    const validateStatusReturnSaveStore = (responseCreateSqlite, statusRequest: number) => {
        console.log('validateStatusReturnSaveStore => statusRequest: ', statusRequest)
        // endpoint ok => return bien
        if (statusRequest == 1 || statusRequest == -1) {
            return statusRequest
        }

        const validResponseCreateSqlite = responseCreateSqlite && typeof responseCreateSqlite === 'object'
        console.log('validResponseCreateSqlite => ', validResponseCreateSqlite)
        // endpoint mal y local bien => return bien
        if (validResponseCreateSqlite && (!statusRequest || statusRequest == 0 || statusRequest == null || statusRequest == undefined)) {
            return 1
        }

        // responseCreateSqlite
        if (responseCreateSqlite == null || responseCreateSqlite == -1) {
            return responseCreateSqlite
        }
    }
    const saveDataPendingSend = async (status: number | null, dataSend: DataSendRequestCreatePos, responseCreateSqlite) => {
        const IS_CREATE_SUCCESS = status === 1

        if (IS_CREATE_SUCCESS) {
            console.log('no hace falta guardar en pendientes')
            return
        }

        const res = await schedulesServices.saveStoresAndOrganizationsPendings(dataSend, responseCreateSqlite)
        console.log('termino saveStoresAndOrganizationsPendings => ', res)
    }

    type Field = { label: string; value: string }
    type Grouped = { [table: string]: Field[] }
    const createStoreInDBLocal = async (status: number | null, dataCreatedOnline: dataCreatedDbLocalI, dataSend: DataSendRequestCreatePos) => {
        try {
            // si IS_CREATE_SUCCESS es true entonces puedo usar los valores de dataCreatedOnline, sino debo usar los de dataSend
            const IS_CREATE_SUCCESS = status === 1
            console.log('IS_CREATE_SUCCESS ====> ', IS_CREATE_SUCCESS)
            const infoCreateStore = await schedulesServices.getInfoCreateStores()

            const { organizationCreate, posCreate, schedulePosCreate } = dataCreatedOnline

            console.log('infoCreateStore => ', infoCreateStore)
            console.log('posCreate => ', posCreate)
            console.log('schedulePosCreate => ', schedulePosCreate)
            let organization: org | number | null = dataSend?.organization || null
            let organizationId = organization ? organization._id : null
            let organizationCode = organization ? organization.code : null
            // Data a crear en organizacion..
            let newOrganization = null
            let isOrganizationValid = true
            if (dataSend.createOrganization == true) {
                newOrganization = await dataOrganization(IS_CREATE_SUCCESS, organizationCreate, dataSend)
                // isOrganizationValid = await validateInsertRegister('organization', newOrganization)
                console.log('172 - isOrganizationValid => ', isOrganizationValid)
                // creo organizacion con el stauts correspondiente que me devuelve dataOrganization

                // organization = await schedulesServices.addOrganization(newOrganization)
                organizationId = newOrganization['_id']
                organizationCode = newOrganization['code']
            }

            const newPos = dataPos(IS_CREATE_SUCCESS, posCreate, dataSend, organizationCode)
            // const isStoreValid = await validateInsertRegister('pos', newPos)
            // console.log('180 --- 🚀 ~ createStoreInDBLocal ~ isStoreValid:', isStoreValid)
            // console.log('newPos => ', newPos)
            const grouped: Grouped = dataSend.validate_unique.reduce((acc, curr) => {
                    if (!acc[curr.table]) acc[curr.table] = []
                    acc[curr.table].push({ label: curr.label, value: curr.value })
                    return acc
            }, {})

            // console.log('grouped => ', grouped)

            // const grp = {
            //     pos: [
            //         { label: 'name', value: 'test412' },
            //         { label: 'code', value: '412' },
            //     ],
            //     pos_companies: [
            //         { label: 'organization_name', value: 'companynew412' },
            //         { label: 'organization_cuit', value: '41-24124124-1' },
            //     ],
            // }
            // console.log('grouped keys => ', Object.keys(grouped))

            /* 
                ["pos_companies", "pos"]
            */

            let hasDuplicate = false

            for (const [table, fields] of Object.entries(grouped)) {
                console.log('1table => ', table)
                console.log('1fields => ', fields)
                // Si algún campo está vacío, lo salteas
                const schema = getTableName(table)

                // const schema = getSchemaByTable(table, schemas)

                const fieldsWithValue = fields
                    .filter(f => f.value && f.value !== '')
                    // .filter(f => f && f.label && f.value && f.table)
                    .map(label => {

                        console.log('label => ', label)

                        if (label.label.includes('organization_')) {
                            label.label = label.label.split('organization_')[1]
                        }

                        if (schema == SCHEDULES_STORE_NAMES.STORES && label.label == 'code') {
                            // const storeCodeConcat = organization_code ? `${organization_code}-${store_code}` : store_code
                            label.value = newPos.code
                        }
                        label.value = textTransformUpperCase(label.value)
                        return label
                    })

                // const validatesUniqueTransform = validate_unique
                // .filter((label) => label && label.label && label.value && label.table)
                // .map((label) => {
                //     if (label.label.includes('organization_')) {
                //         label.label = label.label.split('organization_')[1]
                //     }
                //     if (label.table == 'pos' && label.label == 'code') {
                //         const storeCodeConcat = organization_code ? `${organization_code}-${store_code}` : store_code
                //         label.value = storeCodeConcat
                //     }
                //     return label
                // })
                    console.log('3fieldsWithValue => ', fieldsWithValue)
                if (fieldsWithValue.length === 0) continue

                // Espera la validación de duplicados
                const exists = await schedulesServices.existsInLocalDB(schema, fieldsWithValue)
                console.log('-------- exists => fields => ', exists, ' - schema => ', schema)
                if (exists) {
                    hasDuplicate = true
                    break
                }
            }

            if (hasDuplicate) {
                // Ya existe un registro duplicado
                return -1
            }

            //! retorno -1 si ya existe la organizacion o la tienda
            // if (!isOrganizationValid || !isStoreValid) {
            //     console.log(`store o organizacion ya existe => ${JSON.stringify(isOrganizationValid)} - ${JSON.stringify(isStoreValid)}`)
            //     return -1
            // }

            console.log('newPos => ', newPos)

            if (dataSend.createOrganization == true) {
                organization = await schedulesServices.addOrganization(newOrganization)
            }

            const pos = await schedulesServices.addPos(newPos)

            const newSchedulePos = dataSchedulePos(IS_CREATE_SUCCESS, schedulePosCreate, dataSend, newPos._id, infoCreateStore)
            const schedule_pos = await schedulesServices.addSchedulePos(newSchedulePos)

            return {
                isCreateSuccess: IS_CREATE_SUCCESS,
                organization: organization,
                pos: pos,
                schedule_pos: schedule_pos,
            }
        } catch (error) {
            console.error('createStoreInDBLocal => ', error)
            return null
        }
    }

    const getTableName = (table) => {
        const mapSchemas = {
            pos: SCHEDULES_STORE_NAMES.STORES,
            pos_companies: SCHEDULES_STORE_NAMES.STORES_ORGANIZATIONS,
        }
        return mapSchemas[table] || null
    }

    const validateInsertRegister = async (type: 'pos' | 'organization', dataValidate) => {
        const shouldValidateDuplicates = dataValidate.status === STATUS_SEND.PENDING

        if (!shouldValidateDuplicates) {
            return true
        }

        if (type === 'organization') {
            const organizationExists = await schedulesServices.organizationExists(dataValidate)
            return !organizationExists
        }

        if (type === 'pos') {
            const posExists = await schedulesServices.posExists(dataValidate)
            return !posExists
        }
    }

    const dataOrganization = async (isCreateSuccess: boolean, organizationCreate: OrganizationCreateStore, dataSend: DataSendRequestCreatePos) => {
        if (isCreateSuccess) {
            return {
                _id: organizationCreate._id,
                name: organizationCreate.name,
                cuit: organizationCreate.cuit,
                status: STATUS_SEND.SEND,
                code: organizationCreate.code,
            }
        }

        const newCode: string = await schedulesServices.getNextOrganizationCode()

        return {
            _id: generateUniqueId(),
            name: textTransformUpperCase(dataSend.organization_name),
            cuit: dataSend.organization_cuit,
            status: STATUS_SEND.PENDING,
            code: newCode,
        }
    }

    const dataSchedulePos = (
        isCreateSuccess: boolean,
        schedulePosCreate: SchedulePosCreateStore,
        dataSend: DataSendRequestCreatePos,
        store_id: string,
        infoCreateStore,
    ) => {
        if (isCreateSuccess) {
            return {
                _id: schedulePosCreate._id,
                store_id: schedulePosCreate.store_id,
                schedule_id: schedulePosCreate.schedule_id,
                forms: schedulePosCreate.forms,
                lat: 0,
                lng: 0,
                status_send: STATUS_SEND.SEND,
            }
        }
        const genericId = generateUniqueId()

        return {
            _id: genericId,
            store_id: store_id,
            schedule_id: dataSend.schedule_id,
            forms: infoCreateStore.forms,
            lat: 0,
            lng: 0,
            status_send: STATUS_SEND.PENDING,
        }
    }

    const dataPos = (isCreateSuccess: boolean, posCreate: StoreCreateStore, dataSend: DataSendRequestCreatePos, organization_code: string) => {
        if (isCreateSuccess) {
            return {
                _id: posCreate._id,
                name: posCreate.name,
                address: posCreate.address,
                lat: posCreate.lat,
                lng: posCreate.lng,
                code: posCreate.code,
                cluster: posCreate.cluster,
                area: '',
                region: '',
                flag: '',
                maximum_distance_for_checking: posCreate.maximum_distance_for_checking,
                store_segment: '',
                distributor_id: null,
                // organization_id: organization_id,
                status: STATUS_SEND.SEND,
            }
        }

        const genericId = generateUniqueId()

        return {
            _id: genericId,
            name: textTransformUpperCase(dataSend.name),
            address: textTransformUpperCase(dataSend.address),
            lat: 0,
            lng: 0,
            code: generateCodeStore(dataSend.code, organization_code),
            cluster: dataSend.cluster._id,
            area: '',
            region: '',
            flag: '',
            maximum_distance_for_checking: 0,
            store_segment: '',
            distributor_id: null,
            // organization_id: organization_id,
            status: STATUS_SEND.PENDING,
        }
    }
    const generateCodeStore = (codeStore: string, codeCompany: string) => {
        const newCode = codeCompany + '-' + codeStore
        return textTransformUpperCase(newCode)
    }

    const getLocation = async (): Promise<{ lat: string; lng: string }> => {
        let latitude = null
        let longitude = null

        const userLocation = await PostsServices.getLocationUser()

        const dif_hours = new Date().getTime() - new Date(userLocation.last_update_coords).getTime()

        if (dif_hours > DATE_DIF) {
            // Si la diferencia es mayor a una hora, se considera que la ubicación es antigua

            let { status } = await Location.requestForegroundPermissionsAsync()
            console.log('status', status)
            if (status !== 'granted') {
                // Permiso denegado
                return
            }
            let location = await Location.getCurrentPositionAsync({})
            console.log('location', location)

            latitude = location.coords.latitude
            longitude = location.coords.longitude
        } else {
            latitude = userLocation.lat
            longitude = userLocation.lng
        }

        const result = {
            lat: latitude,
            lng: longitude,
        }
        console.log('result', result)

        return result
    }
    const transformDataKeys = async (form, isVisibleFormOrganization = false): Promise<DataSendRequestCreatePos> => {
        try {
            const { lat, lng } = await getLocation()
            let dataUpdate = { ...form, createOrganization: isVisibleFormOrganization, lat, lng }
            if (form.city) {
                const get_data_address = await schedulesServices.getDataAddressByCityId(form.city._id)
                const COUNTRY = { _id: get_data_address.country_id, name: get_data_address.country_name }
                dataUpdate = { ...dataUpdate, country: COUNTRY }
            }
            console.log("'transformDataKeys => ', form)", JSON.stringify(dataUpdate))

            return dataUpdate
        } catch (error) {
            console.error('transformDataKeys => ', error)
            return null
        }
    }
    const sendStore = async (data) => {
        try {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""

            let response = await request_create_pos({ authToken, data })
            if (!response) {
                throw new Error('request_create_pos response null')
            }

            return {
                status: response.status,
                pos: response.status === 1 ? response.single.pos : null,
                schedule_pos: response.status === 1 ? response.single.schedule_pos : null,
                organization: response.status === 1 ? response.single.organization : null,
            }
        } catch (error) {
            console.error('sendStore => ', error)
            return {
                status: null,
                pos: null,
                schedule_pos: null,
                organization: null,
            }
        }
    }
    interface errorField {
        _id: string
        message: string
    }
    const isValidFieldsForms = async (form, isVisibleFormOrganization) => {
        let formValid = true
        let message = ''
        let invalidFields: errorField[] = []
        let requiredFields = fields.map((field) => {
            let isOrganization = field.organization_field || false
            let isRequired = field.required || false
            // Campos organizacion
            if (isOrganization === true) {
                if (isVisibleFormOrganization === true && isRequired === true) {
                    // console.log('REQUIRED => ', field.name + ' - ' + field._id)
                    return field.name
                }
            } else {
                // Campos tienda
                if (isRequired === true) {
                    if (isVisibleFormOrganization && field.optionsFrom === 'fields_organization') {
                    } else {
                        // console.log('REQUIRED => ', field.name + ' - ' + field._id)
                        return field.name
                    }
                }
            }
        })
        requiredFields = requiredFields.filter((field) => field !== undefined)

        // Validate all fields required exists in answers
        for (const field of requiredFields) {
            // console.log('field => ', field)
            // console.log('FORM', form)
            if (!form.hasOwnProperty(field)) {
                let { placeholder, _id } = fields.find((f) => f.name === field)
                console.log(`Formulario inválido: falta el campo obligatorio => ${placeholder}`)
                formValid = false
                message = `Por favor, completa el campo: ${placeholder}`
                invalidFields.push({ _id: _id, message: `Este campo es obligatorio` })
                // console.log('ACA? => ', invalidFields)
                // return { formValid, message }
            }
        }
        // Validate all fields required are not empty
        for (const field of requiredFields) {
            const value = form[field]
            if (value === null || value === undefined || value === '') {
                let { placeholder, _id } = fields.find((f) => f.name === field)

                // console.log(`Formulario inválido: el campo => ${placeholder} está vacío`)
                formValid = false
                // console.log('placeholder => ', form[field])
                // message = `Por favor, completa el campo: ${placeholder}`
                invalidFields.push({ _id: _id, message: `Este campo es obligatorio` })
                // return { formValid, message }
            }
        }
        // Validate answers restrictions
        for (const field of requiredFields) {
            const value = form[field] || ''
            let { placeholder, configure, _id } = fields.find((f) => f.name === field)
            if (configure != null && configure !== undefined) {
                let min = configure.minLength || 0
                let max = configure.maxLength || 0
                console.log('min => ', min)
                console.log('max => ', max)

                const isValidMin = typeof min === 'number' && min > 0
                const isValidMax = typeof max === 'number' && max > 0

                if (isValidMin || isValidMax) {
                    let alertMessage = ''
                    if (isValidMin && isValidMax && min === max) {
                        if (value.length !== min) {
                            formValid = false
                            alertMessage = `Debe tener exactamente ${min} caracteres`
                            invalidFields.push({ _id: _id, message: alertMessage })
                        }
                    } else {
                        if (isValidMax && value.length > max) {
                            formValid = false
                            alertMessage = `No debe superar ${max} caracteres`
                            invalidFields.push({ _id: _id, message: alertMessage })
                        }
                        if (isValidMin && value.length < min) {
                            formValid = false
                            alertMessage = `Debe tener al menos ${min} caracteres`
                            invalidFields.push({ _id: _id, message: alertMessage })
                        }
                    }
                }
                // formValid = false
                // let alertMessage = ''
                // console.log('value => ', value)
                // console.log('value.length => ', value.length)
                // if (value.length > max) {
                //     alertMessage = `No debe superar ${max} caracteres`
                // } else if (min > 0 && value.length < min) {
                //     alertMessage = `Debe tener al menos ${min} caracteres`
                // }

                // invalidFields.push({ _id: _id, message: alertMessage })
                
            }
        }
        return { formValid, message, invalidFields }
    }
    const getDataFields = async () => {
        try {
            await handleGetDataLocation()
            await loadOptionsOrganizations()
            let resFields = await schedulesServices.getFieldsCreatePos()
            let resFieldsOrganization = await schedulesServices.getFieldOrganizationsCreatePos()

            // console.log('61 ----- res getDataFields => ', resFields)
            if (resFieldsOrganization.length > 0) {
                resFieldsOrganization = resFieldsOrganization.map((field) => {
                    return {
                        ...field,
                        organization_field: true,
                    }
                })
                let orgIndex = resFields.findIndex((field) => field.optionsFrom === 'fields_organization')
                if (orgIndex !== -1) {
                    resFields.splice(orgIndex + 1, 0, ...resFieldsOrganization)
                }
            }
            setFields(resFields)
        } catch (e) {
            console.error('getDataFields => ', e)
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }
    const getDataFieldsOrganization = async () => {
        const res = await schedulesServices.getFieldOrganizationsCreatePos()

        // console.log('res getDataFieldsOrganization => ', res)
    }
    const getDataCountry = async () => {
        const res = await schedulesServices.getCountryData(COUNTRY_ID_ARG)
        // console.log('res getDataCountry => ', res)
    }
    const getProvinces = async () => {
        setOptions(testOptions)
    }
    const handleGetDataLocation = async () => {
        const result = await schedulesServices.getLocationData()
        const { provinces, cities } = result
        console.log('provinces => ', provinces.length)
        console.log('cities => ', cities.length)
        setProvinces(provinces)
        setCities(cities)
        // console.log('result => ', result)
    }

    const loadOptionsOrganizations = async () => {
        const organizations = await schedulesServices.getOrganizations()
        console.log('organizations.length => ', organizations.length)
        if (organizations && organizations.length > 0) {
            setOptionsOrganizations(organizations)
        }
    }

    return {
        fields,
        fieldsOrganization,
        setFields,
        provinces,
        selectedProvince,
        citys,
        setSelectedProvince,
        handleSaveStore,
        transformDataKeys,
        sendStore,
        isValidFieldsForms,
        getDataFields,
        getDataFieldsOrganization,
        getDataCountry,
        getProvinces,
        handleGetDataLocation,
        isVisibleFormOrganization,
        setIsVisibleFormOrganization,
        loading,
        createStoreInDBLocal,
        optionsOrganizations,
        getLocation,
    }
}

const testOptions = [
    { _id: '681249a17e624d30ff9e9ede', name: 'Formosa' },
    { _id: '681249a17e624d30ff9e9edf', name: 'Buenos Aires' },
    { _id: '681249a17e624d30ff9e9ee0', name: 'La Rioja' },
    { _id: '68124f1f7e624d30ffa06317', name: 'Mar del Plata' },
    { _id: '68124f1f7e624d30ffa06318', name: 'Bahía Blanca' },
    { _id: '68124f1f7e624d30ffa06319', name: 'La Plata' },
    { _id: '68124f1f7e624d30ffa0631b', name: 'Tandil' },
    { _id: '68124f1f7e624d30ffa06390', name: 'Longchamps' },
]
